module.exports = __webpack_public_path__ + "fonts/search-icon.svg";